import { About } from "./components/About";
import { ChaosPlayer } from "./components/ChaosPlayer";
import { Contact } from "./components/Contact";
import { Experience } from "./components/Experience";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Noise } from "./components/Noise";
import { Projects } from "./components/Projects";
import { SchoolNow } from "./components/SchoolNow";
import { Toolbox } from "./components/Toolbox";
import { useKonami } from "./hooks/useKonami";
import { LangProvider } from "./lang/LangContext";

function Portfolio() {
  const { active: chaosOn, deactivate } = useKonami();

  return (
    <div style={{ minHeight: "100vh", position: "relative" }}>
      <Noise />
      {chaosOn && <ChaosPlayer onClose={deactivate} />}
      <Header />
      <Hero />
      <About />
      <Projects />
      <Experience />
      <Toolbox />
      <SchoolNow />
      <Contact />
      <Footer />
    </div>
  );
}

export const App = () => (
  <LangProvider>
    <Portfolio />
  </LangProvider>
);
